import { Expose, Transform } from 'class-transformer';
import { PostcodeModel } from 'models';

export class BasketAddressModel {
    @Expose({ name: 'postalCode' })
    @Transform(postcodeTransformer)
    public postcode: PostcodeModel;

    @Expose({ name: 'lastName' })
    public surname: string | null = null;

    @Expose({ name: 'cellPhone' })
    public phone: string | null = null;

    @Expose({ name: 'titleCode' })
    public title: string | null = null;

    public building: string | null = null;

    public apartment: string | null = null;

    public line1: string | null = null;

    public line2: string | null = null;

    public town: string | null = null;

    public district: string | null = null;

    public customerId: string | null = null;

    public email: string | null = null;

    public firstName: string | null = null;

    public formattedAddress: string | null = null;

    public id: string | null = null;

    public country: Country | null = null;
}

interface Country {
    isocode: string;
}

function postcodeTransformer(value: string | PostcodeModel): string | PostcodeModel {
    if (typeof value === 'string') {
        return new PostcodeModel(value);
    }

    return value?.code;
}